import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const insertPodDate = async (payload) => {
  return apiClient(ENDPOINTS.LOGISTIC_INSERT_POD_DATE, {
    method: "POST",
    body: payload,
    headers: { "Content-Type": "application/json" },
  });
};

export const fetchPodDates = async ({ customerId, username }) => {
  let url = "/LogisticDetails/get-pod-date";
  if (customerId) {
    url += `?customerId=${customerId}`;
  } else if (username) {
    url += `?customerId=${username}`;
  }
  return apiClient(url, { method: "GET" });
};
